import { EMITTER_CONSTANTS } from '@/shared/config';
import { useEmitter } from '@/shared/lib/customHooks';
import { useState } from 'react';

/**
 * Drives the notice telling the user a CardioOne study's report cannot be opened in the portal. Opens on the show-popup-c1c-report event and closes through the returned handler.
 *
 * @returns The open flag together with its close handler.
 */
export const useModalC1cReport = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEmitter(EMITTER_CONSTANTS.SHOW_POPUP_C1C_REPORT, () => setIsOpen(true), []);

  /**
   * Dismisses the CardioOne report notice. Clears the open flag in state.
   *
   * @returns Nothing.
   */
  const onClose = () => setIsOpen(false);

  return { isOpen, onClose };
};
